import { bboxToExtent, isSingleLocation } from "./util";
import { containsXY, intersects } from "ol/extent";
import { fromLonLat } from "ol/proj";
export const areCoordinatesInGeometry = (lonLat, geometry, checkExtentFirst = true) => {
    const coords = fromLonLat(lonLat);
    checkExtentFirst = false;
    const isJobInExtent = checkExtentFirst ? containsXY(geometry.getExtent(), coords[0], coords[1]) : true;
    const result = isJobInExtent ? geometry.intersectsCoordinate(coords) : false;
    return result;
};
const filterJobsByGeometry = (jobs, geometries) => {
    if (geometries.length === 0) {
        return jobs;
    }
    else {
        let newShownJobs = [];
        geometries.forEach((geometry) => {
            const newJobs = jobs.filter((job) => {
                const locationsInsideGeometry = job.locations.filter((location) => {
                    if (isSingleLocation(location)) {
                        return areCoordinatesInGeometry([location.lon, location.lat], geometry);
                    }
                    else {
                        let isInside = false;
                        for (const l of location) {
                            if (l.bbox) {
                                const extent = bboxToExtent(l.bbox);
                                if (intersects(extent, geometry.getExtent())) {
                                    isInside = true;
                                    break;
                                }
                            }
                        }
                        return isInside;
                    }
                });
                if (locationsInsideGeometry.length > 0) {
                    job.locations = locationsInsideGeometry;
                    return true;
                }
                return false;
            });
            newShownJobs = newShownJobs.concat(newJobs);
        });
        return newShownJobs;
    }
};
export const filterJobs = (jobs, filter) => {
    if (filter.circle) {
        jobs = filterJobsByGeometry(jobs, [filter.circle]);
    }
    if (filter.geometries) {
        jobs = filterJobsByGeometry(jobs, filter.geometries);
    }
    return jobs;
};
